//Get  all Custom_notification
export const GET_ALL_CUSTOM_NOTIFICATION_REQ = "GET_ALL_CUSTOM_NOTIFICATION_REQ";
export const GET_ALL_CUSTOM_NOTIFICATION_ERR = "GET_ALL_CUSTOM_NOTIFICATION_ERR";
export const GET_ALL_CUSTOM_NOTIFICATION_SUCC = "GET_ALL_CUSTOM_NOTIFICATION_SUCC";

// POST_CUSTOM_NOTIFICATION_READ_STATUS_BY_ID
export const POST_CUSTOM_NOTIFICATION_READ_STATUS_BY_ID_REQ = "POST_CUSTOM_NOTIFICATION_READ_STATUS_BY_ID_REQ";
export const POST_CUSTOM_NOTIFICATION_READ_STATUS_BY_ID_ERR = "POST_CUSTOM_NOTIFICATION_READ_STATUS_BY_ID_ERR";
export const POST_CUSTOM_NOTIFICATION_READ_STATUS_BY_ID_SUCC = "POST_CUSTOM_NOTIFICATION_READ_STATUS_BY_ID_SUCC";